import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {provideState} from '@ngrx/store';
import {provideEffects} from '@ngrx/effects';
import {QUERY_PARAMS_FEATURE_KEY} from '@aviary/store/query-params/query-params.types';
import {queryParamsState} from '@aviary/store/query-params/query-params.state';
import {QueryParamsEffects} from '@aviary/store/query-params/query-params.effects';
import {SnackBarEffects} from '@aviary/store/snack-bar/snack-bar.effects';
import {RouterEffects} from '@aviary/store/router/router.effects';
import {ACTIVE_ROUTER_TAB_FEATURE_KEY} from '@aviary/store/active-router-tab/active-router-tab.types';
import {activeRouterTabState} from '@aviary/store/active-router-tab/active-router-tab.state';
import {PaginationEffects} from '@aviary/store/pagination/pagination.effects';
import {PAGINATION_FEATURE_KEY} from '@aviary/store/pagination/pagination.types';
import {paginationState} from '@aviary/store/pagination/pagination.state';
import {viewportState} from '@aviary/store/viewport/viewport.state';
import {VIEWPORT_FEATURE_KEY} from './viewport/viewport.types';
import {ViewportEffects} from '@aviary/store/viewport/viewport.effects';
import {HTTP_LOADING_FEATURE_KEY} from '@aviary/store/http-loading/http-loading.types';
import {httpLoadingState} from '@aviary/store/http-loading/http-loading.state';

export function provideAviaryStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(ACTIVE_ROUTER_TAB_FEATURE_KEY, activeRouterTabState),
    provideState(HTTP_LOADING_FEATURE_KEY, httpLoadingState),
    provideState(PAGINATION_FEATURE_KEY, paginationState),
    provideState(QUERY_PARAMS_FEATURE_KEY, queryParamsState),
    provideState(VIEWPORT_FEATURE_KEY, viewportState),
    provideEffects(
      PaginationEffects,
      QueryParamsEffects,
      RouterEffects,
      SnackBarEffects,
      ViewportEffects
    )
  ]);
}
